document.addEventListener("DOMContentLoaded",function(){subscribe(PUB_SUB_EVENTS.cartUpdate,function(t){"cart-items"===t.source?Debutify.cart=t.cartData:"product-form"===t.source&&(Debutify.settings.dbtfy_skip_cart?window.location.href="/checkout":fetch(`${routes.cart_url}.js`).then(t=>t.json()).then(t=>{Debutify.cart=t}).catch(t=>{console.error(t)}))})});
(function(){
  var hiddenKey="alandalusChatHidden";
  var selectors=["#shopify-chat","#ShopifyChat","#ShopifyChatWidget","[id*='shopify-chat']","[id*='ShopifyChat']","[class*='shopify-chat']","[class*='ShopifyChat']","iframe[src*='shopify-chat']","iframe[src*='inbox']","iframe[title*='Chat']","iframe[title*='chat']","iframe[aria-label*='Chat']","iframe[aria-label*='chat']"];
  var hiddenClass="alandalus-chat-hidden";
  var buttonClass="alandalus-chat-hide-button";
  var restoreClass="alandalus-chat-restore-button";
  function findChatWidgets(){
    var widgets=[];
    selectors.forEach(function(selector){
      document.querySelectorAll(selector).forEach(function(element){
        var widget=element.closest("div[id], div[class], aside, section")||element;
        if(widget&&widgets.indexOf(widget)===-1&&!widget.classList.contains(restoreClass)){widgets.push(widget)}
      })
    });
    return widgets.filter(function(widget){return widget.offsetWidth>80&&widget.offsetHeight>80})
  }
  function ensureStyles(){
    if(document.getElementById("alandalus-chat-hide-styles")){return}
    var style=document.createElement("style");
    style.id="alandalus-chat-hide-styles";
    style.textContent=".alandalus-chat-hidden{display:none!important}.alandalus-chat-hide-button{position:fixed;right:18px;bottom:min(78vh,560px);z-index:2147483647;width:34px;height:34px;border:0;border-radius:50%;background:#111;color:#fff;font-size:22px;line-height:1;box-shadow:0 2px 10px rgba(0,0,0,.3);cursor:pointer}.alandalus-chat-hide-button:hover,.alandalus-chat-hide-button:focus{background:#333}.alandalus-chat-restore-button{position:fixed;right:16px;bottom:16px;z-index:2147483647;border:0;border-radius:999px;background:#111;color:#fff;padding:10px 14px;font:600 14px/1.2 Arial,sans-serif;box-shadow:0 2px 10px rgba(0,0,0,.3);cursor:pointer}@media(max-width:749px){.alandalus-chat-hide-button{right:14px;bottom:min(72vh,500px)}.alandalus-chat-restore-button{right:14px;bottom:14px}}";
    document.head.appendChild(style)
  }
  function hideChat(){
    sessionStorage.setItem(hiddenKey,"1");
    findChatWidgets().forEach(function(widget){widget.classList.add(hiddenClass)});
    document.querySelectorAll("."+buttonClass).forEach(function(button){button.remove()});
    ensureRestoreButton()
  }
  function showChat(){
    sessionStorage.removeItem(hiddenKey);
    document.querySelectorAll("."+hiddenClass).forEach(function(widget){widget.classList.remove(hiddenClass)});
    document.querySelectorAll("."+restoreClass).forEach(function(button){button.remove()});
    setTimeout(attachHideButtons,250)
  }
  function ensureRestoreButton(){
    if(document.querySelector("."+restoreClass)){return}
    var button=document.createElement("button");
    button.type="button";
    button.className=restoreClass;
    button.textContent="Chat";
    button.setAttribute("aria-label","Show chat");
    button.addEventListener("click",showChat);
    document.body.appendChild(button)
  }
  function attachHideButtons(){
    ensureStyles();
    var widgets=findChatWidgets();
    if(sessionStorage.getItem(hiddenKey)==="1"){
      widgets.forEach(function(widget){widget.classList.add(hiddenClass)});
      document.querySelectorAll("."+buttonClass).forEach(function(button){button.remove()});
      ensureRestoreButton();
      return
    }
    if(widgets.length===0){return}
    if(document.querySelector("."+buttonClass)){return}
    var button=document.createElement("button");
    button.type="button";
    button.className=buttonClass;
    button.innerHTML="&times;";
    button.setAttribute("aria-label","Hide chat");
    button.addEventListener("click",hideChat);
    document.body.appendChild(button)
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",attachHideButtons)
  }else{
    attachHideButtons()
  }
  new MutationObserver(attachHideButtons).observe(document.documentElement,{childList:true,subtree:true})
})();